import Actions from "@/components/Table/Actions.vue";
import CellEndereco from "@/components/Table/CellEndereco.vue";
import CellContatos from "@/components/Table/CellContatos.vue";
import { isEqual } from "lodash";
import { extractErrorMessage } from "@/helpers/functions/errorHelpers";

const defaultParams = {
  search: "q",
};

export function tableMixins(options = defaultParams) {
  return {
    components: { Actions, CellEndereco, CellContatos },
    data: () => ({
      termo_pesquisa: "",
      sortBy: "id",
      sortDesc: false,
      isBusy: false,

      _last_request: {},
    }),
    methods: {
      searchTerm() {
        this.pagination.current_page = 1;
        this.loadData();
        this.$router.push({
          query: {
            page: this.pagination.current_page,
            [options.search]: this.termo_pesquisa,
          },
        });
      },
      sortingChanged(data) {
        this.sortBy = data.sortBy;
        this.sortDesc = data.sortDesc;
        this.loadData();
      },
      async loadData(forceRefetch = false) {
        this.isBusy = true;
        try {
          let payload = {
            page: this.pagination.current_page,
            per_page: this.pagination.per_page,
            orderBy: this.sortBy,
            sortBy: this.sortDesc ? "desc" : "asc",
            [options.search]: this.termo_pesquisa,
          };

          if (forceRefetch || !isEqual(this._last_request, payload)) {
            this._last_request = payload;
            await this.ActionGetAll(payload);
          }
        } catch (error) {
          this.$notifications.addNotification({
            message: "Erro ao carregar dados da listagem",
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
        this.isBusy = false;
      },
      async deleteItem(item) {
        try {
          await this.ActionDelete(item.id);
          this.$notifications.addNotification({
            message: "Registro deletado com sucesso",
            type: "success",
          });
          await this.loadData(true);
        } catch (error) {
          console.log("error", error);
          const message = extractErrorMessage(
            error,
            "Erro ao excluir registro"
          );

          this.$notifications.addNotification({
            message,
            type: "danger",
          });
        }
      },
    },
    async created() {
      let pagination = {
        current_page: 1,
        per_page: 15,
      };

      if (this.$route.query[options.search] != "") {
        this.termo_pesquisa = this.$route.query[options.search];
      }
      if (this.$route.query.page > 1) {
        this.pagination.current_page = this.$route.query.page;
      }

      if (this.ActionSetPagination) {
        await this.ActionSetPagination(pagination);
      }

      await this.loadData();
    },
  };
}

export default tableMixins();
